import type { ClassFeature } from '../types';

// Import the class features JSON directly - Vite will bundle this at build time
// To update classes: run `npm run parse-class-features`
import classFeatures from '../../public/class-features.json';

// Export the classes array with proper typing
export const classes: ClassFeature[] = classFeatures as ClassFeature[];
